import _ from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';

import evaluateDispensaryFeatureFlag from 'shared/utils/evaluate-dispensary-feature-flag';
import { openInfoForDispensaryV2, openInfoForDispensary } from 'shared/core/helpers/dispensaries';
import { GqlDispensarySearchQuery } from 'types/graphql';
import { WhenNotVoid } from 'shared/utils/type-utils';

type Dispensaries = WhenNotVoid<GqlDispensarySearchQuery['filteredDispensaries']>;

export function useSortDispensariesByOpenStatus(dispensaries: Dispensaries): Dispensaries {
  const flags = useFlags();
  const featureFlagValue = flags['rollout.use-updated-ordering-configurations'];

  const closedDispensaries: Dispensaries = [];

  const openDispensaries: Dispensaries = dispensaries.filter((dispensary) => {
    if (!dispensary) {
      return false;
    }
    const flagEnabled = evaluateDispensaryFeatureFlag(
      `rollout.use-updated-ordering-configurations`,
      featureFlagValue,
      String(dispensary.id)
    );
    const openInfo = flagEnabled ? openInfoForDispensaryV2(dispensary) : openInfoForDispensary(dispensary);
    if (_.some(openInfo, `isOpen`)) {
      return true;
    }
    closedDispensaries.push(dispensary);
    return false;
  });

  return [...openDispensaries, ...closedDispensaries];
}
